export default __webpack_public_path__ + "static/media/151-wheelbarrow.b55c608f.png";